export { default } from 'choerodon-ui/dataset/validator/rules/rangeUnderflow';
